import {Box} from '@mui/material'

export interface HighlightedTextProps {
  text?: string
  highlight?: string
}

export const HighlightedText = (props: HighlightedTextProps) => {
  if (!props.text) {
    return <></>
  }
  if (!props.highlight) {
    return <>{props.text}</>
  }

  const regex = `(${props.highlight})`.replace('?', '\\?')
  const parts = props.text.split(new RegExp(regex, 'gi'))
  return (
    <span key={`${props.text}-${props.highlight}`}>
      {parts.map((part) => (
        <Box
          component={'span'}
          key={`${props.text}-${props.highlight}-${part}`}
          sx={
            part.toLowerCase() === props.highlight?.toLowerCase()
              ? {backgroundColor: 'primary.light'}
              : {}
          }
        >
          {part}
        </Box>
      ))}
    </span>
  )
}
